package com.example.mystybag.core.expected

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

actual object DateTimeHelper {
    actual fun formatDateForServerWithTimezone(date: Long): String = Instant.fromEpochMilliseconds(date).toString()
    actual fun getDateTimeMinusMilliseconds(minusMilliseconds: Long): String = Instant.fromEpochMilliseconds(Clock.System.now().toEpochMilliseconds() - minusMilliseconds).toString()
    actual fun isYesterday(date: String): Boolean = false
    actual fun isToday(date: String): Boolean = true
    actual fun isToday(date: String, format: String): Boolean = true
    actual fun formatDate(date: String): String = date
    actual fun formatDate(date: String, fromPattern: String, toPattern: String): String = date
    actual fun formatTaxDate(date: String): String = date
    actual fun parseDateFromMilliseconds(milliseconds: Long): String = Instant.fromEpochMilliseconds(milliseconds).toString()
    actual fun formatMillisecondsToHour(milliseconds: Long): String = (milliseconds / 3600000).toString()
    actual fun parseDate(milliseconds: Long, pattern: String): String = Instant.fromEpochMilliseconds(milliseconds).toString()
    actual fun addTimeToDate(date: Long, milliseconds: Long?, days: Int?, months: Int?, years: Int?): Long = date
    actual fun removeTimeFromDate(date: Long, milliseconds: Long?, days: Int?, months: Int?, years: Int?): Long = date
    actual fun getCurrentDate(): DateInfo {
        val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
        return DateInfo(now.year, now.monthNumber, now.dayOfMonth)
    }
    actual fun formatNotEventDate(date: String?): String? = date
    actual fun getCurrentDateAndTime(): String? = Clock.System.now().toString()
    actual fun convertDateToLong(date: String, pattern: String): Long = 0L
    actual fun getStartOfDayMilliseconds(): Long = Clock.System.now().toEpochMilliseconds()
    actual fun getEgnFromMilliseconds(milliseconds: Long): String = ""
}
